export default (state = {}, action) => {
    switch (action.type) {
        case 'GET_NEXT_BUS':
            return {
                ...state,
                nextBus: action.payload,
            };
        case 'GET_NEXT_TRAIN':
            return {
                ...state,
                nextTrain: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/transport.js